import store from '@/stores';
import Authentication from './authentication';
import { refreshTokensOnce, type TokenRefreshFailureReason } from './api';

const authentication = new Authentication();

export type SessionEnsureResult =
  | { ok: true }
  | { ok: false; reason: TokenRefreshFailureReason };

/**
 * Redux 上の期限が切れていても refresh Cookie が生きていれば復旧する。
 * WebSocket 通知や useSocketEvent の前に呼ぶ。
 */
export async function ensureSessionValidOrRefresh(): Promise<SessionEnsureResult> {
  const accessTokenExpiresAt = store.getState().authenticated.accessTokenExpiresAt;
  if (authentication.isSessionValid(accessTokenExpiresAt)) {
    return { ok: true };
  }
  return refreshTokensOnce({ bypassCooldown: true });
}
